"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Claimable = void 0;
const zod_1 = require("zod");
/**
 * Represents the claimable data in an attestation.
 *
 * The claimable is the core information being verified or asserted about a user.
 * It can range from simple statements to complex, structured data, For example - credentials, identity information,
 * ownership and more.
 */
exports.Claimable = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({ type: zod_1.z.literal('cred'), slug: zod_1.z.string() }),
    zod_1.z.object({ type: zod_1.z.literal('dummy'), name: zod_1.z.string() }), // Not really used, for sake of ts compiler checks.
    // TODO: additional claimable data types
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xhaW1hYmxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2NsYWltYWJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkI7Ozs7OztHQU1HO0FBQ1UsUUFBQSxTQUFTLEdBQUcsT0FBQyxDQUFDLGtCQUFrQixDQUFDLE1BQU0sRUFBRTtJQUNwRCxPQUFDLENBQUMsTUFBTSxDQUFDLEVBQUUsSUFBSSxFQUFFLE9BQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsSUFBSSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDO0lBQ3ZELE9BQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxJQUFJLEVBQUUsT0FBQyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsRUFBRSxJQUFJLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFLENBQUMsRUFBRSxtREFBbUQ7SUFDN0csd0NBQXdDO0NBQ3pDLENBQUMsQ0FBQSJ9